import { render, staticRenderFns } from "./OrderInfoComponent.vue?vue&type=template&id=2513bd8e&scoped=true&"
import script from "./OrderInfoComponent.vue?vue&type=script&lang=js&"
export * from "./OrderInfoComponent.vue?vue&type=script&lang=js&"
import style0 from "./OrderInfoComponent.vue?vue&type=style&index=0&id=2513bd8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2513bd8e",
  null
  
)

export default component.exports